import axios from './axiosConfig';

export const stylingAPI = {
    getStyles
};

function getStyles() {
    return axios.get('/getStyling.php')
        .then( response =>  response ? response.data : null)
        .catch( err => console.log(err));
}

